import React from 'react'
import { connect } from 'react-redux'
import HeaderTitle from '../Header/HeaderTitle'
import {
  createPrintJob,
  getPrinterNames,
  clearMessage,
} from '../../store/PrintFile/actionCreator'
import {
  Grid,
  Typography,
  Card,
  CardActions,
  CircularProgress,
  Button,
  FormControl,
  InputLabel,
  Select,
  TextField,
  MenuItem,
} from '@mui/material'
import PrintSuccessModal from './PrintSuccessModal'
import { truncateLocationId } from '../../common/tLocationNumbers'
import { styled } from '@mui/material/styles'
import { ziptieColors } from '../../config/themeConfig'
import {
  handleFireflySendEvent,
  handleFireflySendClickEvent,
} from '../Utils/FireFlyVnextHelpers'

export class PrintFile extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      printerNameList: [],
      locationId: '',
      hostname: '',
      selectedFile: null,
      eventsMessage: '',
      loading: false,
      statusOpen: false,
    }
    this.baseState = { ...this.state }
    this.handleStatusClose = this.handleStatusClose.bind(this)
    this.createNewPrint = this.createNewPrint.bind(this)
    this.loadPrinters = this.loadPrinters.bind(this)
    this.validateForm = this.validateForm.bind(this)
    this.dialogBox = React.createRef()
  }

  async componentDidMount() {
    const { userInfo } = this.props
    if (userInfo.email !== '') {
      handleFireflySendEvent(
        'PAGE_VIEW',
        'Print File',
        'Print File Page Load',
        userInfo,
      )
    }
  }

  static defaultProps = {
    userInfo: {
      lanId: undefined,
      email: undefined,
    },
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      printerNameList: JSON.parse(JSON.stringify(nextProps.printerNameList)),
      eventsMessage: nextProps.eventsMessage,
    })
  }

  handleStatusOpen() {
    this.setState({ statusOpen: true })
  }

  handleStatusClose() {
    this.setState({
      statusOpen: false,
    })
  }

  loadPrinters(locationId) {
    if (truncateLocationId(locationId) !== '') {
      this.props.getPrinterNames(truncateLocationId(locationId))
    }
  }

  fileData = () => {
    if (this.state.selectedFile !== null) {
      return <p>{this.state.selectedFile.name}</p>
    }
  }

  createNewPrint = (event, selectedFile, locationId, hostname, user) => {
    handleFireflySendClickEvent(
      'CLICK',
      'Print File',
      'Print File - Print',
      user,
    )
    event.preventDefault()
    this.props.clearMessage()
    const userId = user.lanId
    const printFileData = {
      locationId: parseInt(truncateLocationId(locationId)),
      printerName: hostname,
      userId: userId,
    }
    this.props.createPrintJob(printFileData, selectedFile)
    this.setState({ statusOpen: true })
    this.resetForm()
  }

  resetForm = () => {
    this.setState({
      locationId: '',
      selectedFile: null,
      hostname: '',
      buttonEnabled: false,
    })
  }

  validateForm = () => {
    if (
      this.state.locationId !== '' &&
      this.state.selectedFile !== null &&
      this.state.hostname !== '' &&
      this.state.hostname !== 'Error Loading Printer Names'
    ) {
      this.setState({ buttonEnabled: true })
    } else {
      this.setState({ buttonEnabled: false })
    }
  }

  render() {
    const { userInfo } = this.props
    let modalTitle
    if (this.state.eventsMessage === 'Print Job Sent!') {
      modalTitle = 'Success'
    } else if (
      this.state.eventsMessage !== undefined &&
      this.state.eventsMessage.length > 1 &&
      this.state.eventsMessage !== 'Print Job Sent!'
    ) {
      modalTitle = 'Error'
    } else {
      modalTitle = ''
    }
    const CardBannerGrid = styled(Grid)(({ theme }) => ({
      width: '100%',
      height: '65.5px',
      padding: '20px',
      marginBottom: '2%',
      color: ziptieColors.primary.contrastText,
      backgroundColor:
        process.env.REACT_APP_ENV === 'stg'
          ? ziptieColors.development.main
          : ziptieColors.primary.main,
      fontSize: '16px',
      fontWeight: '500',
      lineHeight: '1.75',
      display: 'flex',
      alignItems: 'center',
    }))
    return (
      <div>
        <HeaderTitle title="Print Files" />
        {this.state.loading ? (
          <Grid
            container
            spacing={16}
            justifyContent={'center'}
            className="progress"
          >
            <CircularProgress />
            <Typography className="loading">&nbsp;Loading...</Typography>
          </Grid>
        ) : (
          <Grid item size={{ xs: 12 }}>
            <Grid item size={{ xs: 5 }}>
              <Card style={{ height: '60vh' }}>
                <CardBannerGrid container>
                  <Grid item>PRINT FILE TO LABEL</Grid>
                </CardBannerGrid>
                <form
                  onSubmit={(event) =>
                    this.createNewPrint(
                      event,
                      this.state.selectedFile,
                      this.state.locationId,
                      this.state.hostname,
                      userInfo,
                    )
                  }
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    marginTop: '6%',
                  }}
                >
                  <Grid
                    container
                    style={{
                      paddingLeft: 8,
                    }}
                  >
                    <Grid
                      item
                      size={{ xs: 12, md: 10 }}
                      style={{
                        width: '70%',
                        margin: '2%',
                      }}
                    >
                      <TextField
                        htmlFor="locationId"
                        type="text"
                        variant="standard"
                        value={this.state.locationId}
                        placeholder="Example: 3"
                        label="Store Number"
                        required
                        style={{ width: '50%' }}
                        onBlur={(event) => {
                          this.setState(function () {
                            if (this.state.locationId !== '') {
                              this.loadPrinters(this.state.locationId)
                            }
                          })
                        }}
                        onChange={(event) => {
                          this.setState(
                            {
                              locationId: event.target.value,
                            },
                            function () {
                              this.validateForm()
                            },
                          )
                        }}
                        slotProps={{
                          className: 'redUnderline',
                          name: 'locationId',
                          id: 'locationId',
                        }}
                      />
                    </Grid>
                    <br />
                    <Grid
                      item
                      size={{ xs: 12, md: 10 }}
                      style={{
                        width: '70%',
                        margin: '2%',
                      }}
                    >
                      <FormControl
                        variant="standard"
                        style={{
                          width: '100%',
                          display: 'inline-flex',
                          flexDirection: 'column',
                          justifyContent: 'center',
                          flexBasis: '90%',
                          position: 'relative',
                        }}
                      >
                        <InputLabel
                          htmlFor="hostname"
                          style={{
                            maxWidth: '100%',
                          }}
                        >
                          Printer Hostname
                        </InputLabel>
                        <Select
                          value={this.state.hostname}
                          onChange={(event) => {
                            this.setState(
                              { hostname: event.target.value },
                              function () {
                                this.validateForm()
                              },
                            )
                          }}
                          inputProps={{
                            name: 'hostname',
                            id: 'hostname',
                          }}
                        >
                          {this.state.printerNameList.length > 0
                            ? this.state.printerNameList.map((printerName) => (
                                <MenuItem
                                  value={
                                    printerName.printer_name != null &&
                                    printerName.printer_name.includes('T')
                                      ? printerName.printer_name.split(
                                          '.',
                                          1,
                                        )[0]
                                      : printerName.printer_name
                                  }
                                >
                                  {printerName.printer_name != null &&
                                  printerName.printer_name.includes('T')
                                    ? printerName.printer_name.split('.', 1)[0]
                                    : printerName.printer_name}
                                  {' - '}
                                  {printerName.display_name}
                                </MenuItem>
                              ))
                            : ''}
                        </Select>
                      </FormControl>
                    </Grid>
                    <br />
                    <Grid
                      item
                      size={{ xs: 12, md: 10 }}
                      style={{
                        width: '70%',
                        margin: '2%',
                      }}
                    >
                      <input
                        id="selectedFile"
                        type="file"
                        hidden
                        key={this.state.selectedFile}
                        accept="application/pdf"
                        onChange={(event) => {
                          this.setState(
                            { selectedFile: event.target.files[0] },
                            function () {
                              this.validateForm()
                            },
                          )
                        }}
                      />
                      <label htmlFor="selectedFile">
                        <Button
                          variant="contained"
                          type="file"
                          color="primary"
                          component="span"
                        >
                          Choose File
                        </Button>
                      </label>
                      {this.fileData()}
                    </Grid>
                    <CardActions style={{ width: '100%' }}>
                      <Grid
                        item
                        size={{ xs: 12 }}
                        style={{
                          marginTop: 20,
                          width: '100%',
                          display: 'flex',
                          justifyContent: 'flex-end',
                        }}
                      >
                        <Button
                          type="submit"
                          variant="contained"
                          color="secondary"
                          disabled={!this.state.buttonEnabled}
                        >
                          Print
                        </Button>
                      </Grid>
                    </CardActions>
                  </Grid>
                </form>
              </Card>
              <PrintSuccessModal
                open={this.state.statusOpen}
                handleClose={this.handleStatusClose}
                eventsMessage={this.state.eventsMessage}
                title={modalTitle}
              />
            </Grid>
          </Grid>
        )}
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    userInfo: state.auth.userInfo,
    printerNameList: state.printFile.printerNameList,
    eventsMessage: state.printFile.eventsMessage,
  }
}

const mapDispatchToProps = {
  createPrintJob,
  getPrinterNames,
  clearMessage,
}

export default connect(mapStateToProps, mapDispatchToProps)(PrintFile)
